import * as React from "react";
const SvgArrowNarrowLeft = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "shrink-0", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "arrow-narrow-left" }, /* @__PURE__ */ React.createElement("path", { id: "Icon", d: "M20 12H4M4 12L10 18M4 12L10 6", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
export default SvgArrowNarrowLeft;
